import Logger from '@/lib/logger';
import { NEXT_PUBLIC_BRAZE_LOGGING_ENABLED } from '@/lib/env';

const logger = new Logger('Braze', 'DEBUG');

if (NEXT_PUBLIC_BRAZE_LOGGING_ENABLED) {
  logger.enable();
}

export default logger;
